import {RefObject, useEffect} from 'react';

export const useWheelZoom = (
    containerRef: RefObject<HTMLElement | null>,
    onZoom: (delta: number) => void,
    step = 0.1
) => {
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const onWheel = (e: WheelEvent) => {
            e.preventDefault();
            onZoom(e.deltaY > 0 ? -step : step);
        };

        container.addEventListener('wheel', onWheel, {passive: false});
        return () => container.removeEventListener('wheel', onWheel);
    }, [containerRef, onZoom, step]);
};
